export default {
  title: "Administrační panel",

  titles: {
    adminPanel: "Administrační panel",
    creditDistribution: "Distribuce kreditů",
    financialOverview: "Celkový přehled kreditů",
    members: "Členové",
    addMember: "Přidat člena",
    bulkUpload: "Přidání členů",
    csvUploadMembers: "Přidat existující členy do skupiny",
    groups: "Skupiny",
    noGroups: "Žádné skupiny neexistují",
    unknownEntity: "Neznámá entita",
    organization: "Organizace",
    group: "Skupina",
    ofGroup: "skupiny",
    ofOrganization: "organizace",
  },

  statistics: {
    usedCredits: "Použité kredity",
    distributedCredits: "Distribuované kredity",
    remainingDistributed: "Zbývající distribuované",
    unassignedCredits: "Nepřidělené kredity",
    totalCredits: "Celkové kredity",
  },

  search: {
    placeholder: "Hledat členy...",
    groupsPlaceholder: "Hledat skupiny...",
  },

  table: {
    headers: {
      name: "Jméno",
      lastName: "Příjmení",
      createdAt: "Vytvořeno",
      groupName: "Název skupiny",
      groupDescription: "Popis skupiny",
      members: "Členové",
      learningPaths: "Kurzy",
      aiProfiles: "Modelové situace",
      allowSubgroups: "Povolit podskupiny",
      email: "Email",
      role: "Role",
      credits: "Kredity",
      used: "Použité Kr.",
      startedJourneys: "Započaté Kurzy",
      finishedJourneys: "Dokončené Kurzy",
      limit: "Distribuční Limit kreditů",
      actions: "Akce",
      creditsPerOrganization: "Zbývající kredity",
      usedCreditsPerOrganization: "Použité kredity",
      memberSelectPlaceholder: "Výběr členů",
      searchPlaceholder: "Prohledat...",
      learningPathsPlaceholder: "Výběr kurzů",
      aiProfilesPlaceholder: "Výběr modelových situací",
      addDescriptionPlaceholder: "Přidat popis",
      user: "Uživatel",
      groups: "Skupiny",
    },
    roles: {
      admin: "Administrátor",
      manager: "Manažer",
      employee: "Zaměstnanec",
    },
    actions: {
      edit: "Upravit",
      delete: "Smazat",
      save: "Uložit změny",
      saveGroupChanges: "Uložit změny skupin",
      add: "Přidat",
      close: "Zavřít",
      bulkUpload: "Nahrát přes CSV",
      upload: "Nahrát",
      uploadCsv: "Nahrát CSV",
      addToGroup: "Přidat do skupiny",
      createGroup: "Vytvořit skupinu",
      createSubgroup: "Vytvořit podskupinu",
      openInNewTab: "Otevřít skupinu v novém okně",
      expand: "Rozbalit podskupiny",
      collapse: "Sbalit podskupiny",
      deleteMemberFromGroup: "Odebrat člena ze skupiny",
      deleteMemberFromOrg: "Odebrat člena z organizace",
      copySetupLink: "Zkopírovat link na nastavení hesla",
    },
  },

  bulkUpload: {
    globalGroupSelection: "Přiřadit skupiny všem členům",
    globalGroupDescription: "Vyberte skupiny, které budou přiřazeny všem nahrávaným členům. Jednotlivé skupiny můžete stále upravit níže.",
    selectGroups: "Vyberte skupiny...",
    selectGroupsForAll: "Vyberte skupiny pro všechny členy",
    selectUserGroups: "Vyberte skupiny",
    groupsFor: "Skupiny pro",
    noGroupsAvailable: "Žádné skupiny nejsou k dispozici",
    globalCreditsSelection: "Přiřadit kredity všem členům",
    availableCredits: "Dostupné kredity",
    creditsPerUser: "Kredity na uživatele",
    creditsPlaceholder: "Zadejte množství kreditů...",
    totalNeeded: "Celkem",
    existingCreditsInfo: "Aktuálně přiřazeno: {credits} kreditů",
    existingCreditsTooltip: "Pokud zadáte nižší hodnotu, rozdíl se vrátí do nepřiřazených kreditů organizace.",
  },

  inputs: {
    newMember: {
      email: "Email",
      firstName: "Jméno",
      lastName: "Příjmení",
      title: "Titul",
      subTitle: "Podtitul",
      phone: "Telefon",
      memberDescription: "Popis",
      dateOfBirth: "Datum narození",
      position: "Pozice",
      memberImage: "Obrázek",
    },
  },

  messages: {
    memberAddSuccess: "Člen byl úspěšně přidán.",
    setupLinkCopied: "Link na nastavení hesla byl zkopírován do schránky. Pozor: starší odkazy přestanou fungovat.",
    setupLinkCopyManual: "Kopírování se nepodařilo, zkopírujte link ručně: {link}",
    setupLinkCopyFail: "Link se nepodařilo vygenerovat.",
    memberAddSuccessEmailFail: "Člen byl přidán, ale e-mail s odkazem se nepodařilo odeslat. Znovu ho můžete poslat ve Správě uživatelů.",
    memberAddFail: "Člena se nepodařilo přidat.",
    memberEditSuccess: "Člen byl úspěšně upraven.",
    memberEditFail: "Člena se nepodařilo upravit.",
    memberDeleteSuccess: "Člen byl úspěšně odstraněn.",
    memberDeleteFail: "Člena se nepodařilo odstranit.",
    memberMarkedForDeletion: "Člen označen ke smazání. Klikněte na 'Uložit změny' pro potvrzení.",
    changesSaved: "Změny byly úspěšně uloženy.",
    changesNotSaved: "Změny se nepodařilo uložit.",
    bulkUploadSuccess: "Členové byli úspěšně přidáni.",
    bulkUploadSomeFailed: "Některé členy se nepodařilo přidat ({count}).",
    bulkUploadEmailFail: "Některým členům ({count}) se nepodařilo odeslat e-mail s odkazem - lze znovu poslat ve Správě uživatelů.",
    bulkUploadFail: "Členy se nepodařilo přidat.",
    unsaveChanges: "Máte neuložené změny. Opravdu chcete odejít?",
    missingMemberData: "Některá pole nejsou vyplněna. Prosím vyplňte všechna povinná pole.",
    correctCsvFormat: "CSV soubor musí mít následující formát a musí mít pouze 3 sloupce s těmito názvy: firstName | lastName | email",
    wrongCsvFormat: "CSV soubor nemá správný formát, musí mít pouze 3 sloupce s těmito názvy: firstName | lastName | email",
    notEnoughCredits: "Nemáte dostatek kreditů pro tuto akci.",
    invalidCredits: "Neplatná hodnota kreditů.",
    deleteGroup: "Opravdu chcete smazat tuto skupinu {name}?",
    groupDeleteSuccess: "Skupina byla úspěšně odstraněna.",
    groupDeleteFail: "Skupinu se nepodařilo odstranit.",
    saveBeforeNavigation: "Před otevřením skupiny v novém okně prosím uložte své změny.",
    csvUsersPreview: "V CSV souboru bylo nalezeno {count} platných uživatelů:",
    csvMembersAddedToGroup: "Úspěšně přidáno {count} členů do skupiny '{groupName}'",
    csvMembersAlsoAddedToParents: " (také přidáno do {parentCount} nadřazených skupin)",
    csvUploadFailed: "Nepodařilo se přidat členy do skupiny",
    csvUsersNotFound: "Následující uživatelé nebyli nalezeni v organizaci: {emails}",
    noValidUsersFound: "V CSV souboru nebyly nalezeni žádní platní existující uživatelé",
    subgroupsNotAllowed: "Tato skupina neumožňuje vytváření podskupin",
    subgroupCreated: "Podskupina byla úspěšně vytvořena pod '{parentName}'",
    subgroupCreationFailed: "Nepodařilo se vytvořit podskupinu",
    deleteMember: "Opravdu chcete smazat tohoto člena: {email}?",
  },
};
